<!-- <app-header></app-header> -->

<header class="header">
  <div class="header-inner">
    <img src="assets/snp Image/size changed png (1).jpg" alt="SNP Money Logo" class="logo">
    <h1 class="header-title">Discover How to Plan and Retire Early With SIP/Mutual Fund Investment!!!</h1>
  </div>
</header>

<section class="intro">
  <div class="intro-container">
    <!-- Left Section: Profile -->
    <div class="intro-left">
      <div class="profile">
        <img src="assets/Audience/Sunil_Shrivastav.png" alt="Sunil Srivastava" class="profile-image">
        <h2 class="profile-name">Sunil Srivastava</h2>
        <p class="profile-role">Founder (SNP Money), Financial Planner</p>
        <p class="profile-experience">17+ Years Experience in Finance</p>
        <div class="intro-details">
          <p><strong>Location:</strong> Live Zoom Webinar Online</p>
          <p><strong>Date & Time:</strong> Every Saturday, the webinar starts at 7:30pm</p>
        </div>
      </div>
    </div>

    <!-- Right Section: Compact Form -->
    <div class="intro-right" id="registrationForm">
      <div class="compact-form">
        <form [formGroup]="compactForm" (ngSubmit)="onSubmit()">
          <h2>Register for Webinar for FREE</h2>
          <input formControlName="full_name" type="text" placeholder="Name" required>
          <input formControlName="phone" type="tel" placeholder="Phone" required>
          <input formControlName="email" type="email" placeholder="Email" required>

          <button type="submit">Submit</button>
        </form>
        <div *ngIf="isFormSubmitted" class="thank-you-message animated">
          <h3>
            Thank you for your enquiry! We will get back to you shortly!
            <span class="smiley"></span>
          </h3>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Countdown Section -->
<div class="countdown">
  <h2 class="countdown-title">Registration closes in</h2>
  <div id="countdown-timer" class="countdown-timer">
    <div class="time-unit">{{ minutes }}</div> Minutes
    <div class="time-unit">{{ seconds }}</div> Seconds
  </div>
  <p>{{ countdownMessage }}</p>
</div>

<!-- Why Join Section -->
<section class="why-join-section">
  <div class="container">
    <div class="why-join-image">
      <img src="assets\Audience\18953915_6048753.jpg" alt="Webinar Illustration">
    </div>
    <div class="why-join-content">
      <h2 class="section-title">Why Join Early Retirement Webinar?</h2>
      <div class="reasons">
        <div class="reason">
          <p>Retire before the standard age of 60 so that you have more time for yourself and your family.</p>
        </div>
        <div class="reason">
          <p>Have a consistent flow of income post-retirement even when you are not working.</p>
        </div>
        <div class="reason">
          <p>Live a stress-free life and be confident that your money is working for you to give you a secure future.
          </p>
        </div>
        <div class="reason">
          <p>Have a strategic retirement plan in place to beat inflation and make sure you will never run out of cash.
          </p>
        </div>
      </div>
      <a (click)="scrollToForm('registrationForm')" class="cta-button">Register for FREE</a>
    </div>
  </div>
</section>

<!-- Discovery Section -->
<section class="discovery">
  <h2 class="section-title">What will be discovered in 90 minutes Webinar</h2>
  <div class="discovery-cards">
    <div class="card">
      <h3>How Much Money is Required to Invest Monthly or One-Time</h3>
      <p>Learn how to determine the right investment amount for your goals.</p>
    </div>
    <div class="card">
      <h3>How to Create a Portfolio of Mutual Funds</h3>
      <p>Learn how to build and manage a diversified mutual fund portfolio tailored for retirement.</p>
    </div>
    <div class="card">
      <h3>How to Invest Online and Track Investments via a Mobile App</h3>
      <p>Discover the easiest way to invest and track your investments on a mobile app.</p>
    </div>
  </div>
  <a (click)="scrollToForm('registrationForm')" class="cta-button">Register for FREE</a>
</section>

<!-- Audience Section -->
<section class="audience">
  <h2 class="section-title">This Webinar is Best Suitable for...</h2>
  <div class="audience-grid">
    <div class="audience-card">
      <img src="assets/Audience/1.png" alt="Working Salaried Person">
      <div class="audience-text">Working Salaried Person</div>
    </div>
    <div class="audience-card">
      <img src="assets/Audience/2.png" alt="Business Owners">
      <div class="audience-text">Business Owners</div>
    </div>
    <div class="audience-card">
      <img src="assets/Audience/3.png" alt="Self-Employed Professionals">
      <div class="audience-text">Self-Employed Professionals</div>
    </div>
    <div class="audience-card">
      <img src="assets/Audience/4.png" alt="Freelancers & Solopreneurs">
      <div class="audience-text">Freelancers & Solopreneurs</div>
    </div>
    <div class="d1-flex justify-content-center">
      <a (click)="scrollToForm('registrationForm')" class="cta-button btn btn-primary">Register for FREE</a>
    </div>
  </div>
</section>



<footer class="footer">
  <p>&copy; 2024 SNP Money. All rights reserved. | <a href="mailto:support@snpmoney.com" class="footer-link">Contact
      Us</a></p>
</footer>
